import { render, staticRenderFns } from "./CustomerTables.vue?vue&type=template&id=76f8a9e6"
import script from "./CustomerTables.vue?vue&type=script&lang=js"
export * from "./CustomerTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports